import t from "./index.ce.vue2.js";
import o from "./index.ce.vue3.js";
import r from "../../_virtual/_plugin-vue_export-helper.js";
const _ = /* @__PURE__ */ r(t, [["styles", [o]]]);
export {
  _ as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/batch-transmit/index.ce.vue.js
// module id = 1176
// module chunks = 41